var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { InfoIcon } from '@shapeable/icons';
import { useTooltipEffect } from '../hooks/use-tooltip-effect';
import ReactTooltip from 'react-tooltip';
var cls = classNames('info-tooltip');
export var InfoTooltipDefaultProps = {
  iconSize: 12,
  hasLeftBorder: false,
  showIcon: true
  // colors: {
  //   text: 'strong-chrome',
  //   background: 'subtle-chrome',
  //   fill: 'strong-chrome',
  // }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0;\n    user-select: none;\n    position: sticky;\n    top: 0;\n    z-index: 3;\n    font-size: ", ";\n    text-transform: uppercase;\n\n    .__react_component_tooltip {\n      border-radius: ", " !important;\n      padding: ", " ", " !important;\n    }\n\n  "], ["\n    padding: 0;\n    user-select: none;\n    position: sticky;\n    top: 0;\n    z-index: 3;\n    font-size: ", ";\n    text-transform: uppercase;\n\n    .__react_component_tooltip {\n      border-radius: ", " !important;\n      padding: ", " ", " !important;\n    }\n\n  "])), theme.FONT_SIZE(11), theme.UNIT(3), theme.UNIT(2.5), theme.UNIT(4))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n\n    ", "\n\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    min-height: 12px;\n    min-height: 36px;\n    align-items: center;\n    justify-content: space-between;\n  "], ["\n    border-bottom: 1px solid ", ";\n\n    ", "\n\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    min-height: 12px;\n    min-height: 36px;\n    align-items: center;\n    justify-content: space-between;\n  "])), theme.COLOR('line-semi-subtle'), function (_a) {
    var hasLeftBorder = _a.hasLeftBorder;
    return hasLeftBorder && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-left: 1px solid ", ";\n    "], ["\n      border-left: 1px solid ", ";\n    "])), theme.COLOR('line-semi-subtle'));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1em;\n    min-height: 12px;\n    font-weight: 400;\n    text-transform: uppercase;\n    color: inherit;\n    padding: ", " ", ";\n    white-space: nowrap;\n  "], ["\n    font-size: 1em;\n    min-height: 12px;\n    font-weight: 400;\n    text-transform: uppercase;\n    color: inherit;\n    padding: ", " ", ";\n    white-space: nowrap;\n  "])), theme.UNIT(2.5), theme.UNIT(3))
});
var InfoTargetStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    svg { display: block; }\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: ", ";\n    ", ";\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "], ["\n    svg { display: block; }\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: ", ";\n    ", ";\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "])), theme.UNIT(3), theme.TRANSITION('filter'))
});
var InfoStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TooltipBodyStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    text-align: left;\n    font-size: ", ";\n  "], ["\n    text-align: left;\n    font-size: ", ";\n  "])), theme.FONT_SIZE(11))
});
var TooltipStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    text-transform: none;\n    max-width: 200px;\n    line-height: 1.3em;\n    font-weight: 400;\n    font-size: ", ";\n\n  "], ["\n    text-transform: none;\n    max-width: 200px;\n    line-height: 1.3em;\n    font-weight: 400;\n    font-size: ", ";\n\n  "])), theme.FONT_SIZE(11))
});
var TargetChildrenStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    text-transform: none;\n    font-size: 1em;\n  "], ["\n    text-transform: none;\n    font-size: 1em;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'InfoTooltip',
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Tooltip: styled(ReactTooltip)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TooltipStyles),
  TooltipBody: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TooltipBodyStyles),
  InfoTarget: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), InfoTargetStyles),
  Info: styled(InfoIcon)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  TargetChildrenStyles: styled.span(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), TargetChildrenStyles)
};
export var InfoTooltip = function (props) {
  var componentProps = useComponentProps(My.NAME, InfoTooltipDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    tooltip = componentProps.tooltip,
    showIcon = componentProps.showIcon,
    id = componentProps.id,
    iconSize = componentProps.iconSize;
  useTooltipEffect();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, tooltip && React.createElement(My.Tooltip, {
    id: "tooltip-".concat(id),
    effect: "solid",
    place: "top",
    type: "light",
    delayHide: 300,
    delayShow: 100,
    offset: {
      top: 0,
      left: 0
    },
    textColor: "#FFFFFFFF",
    backgroundColor: "#333333",
    clickable: true,
    wrapper: "span"
  }, React.createElement(My.TooltipBody, {
    id: "tooltip-".concat(id)
  }, tooltip)), React.createElement(My.TargetChildrenStyles, {
    "data-for": tooltip ? "tooltip-".concat(id) : undefined,
    "data-tip": ""
  }, children), tooltip && showIcon && React.createElement(My.InfoTarget, {
    "data-for": "tooltip-".concat(id),
    "data-tip": ""
  }, React.createElement(My.Info, {
    size: iconSize
  })));
};
InfoTooltip.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;